export interface IPropertyPresentable<T> {
  getValue(): T;
}

export function instanceOfIPropertyPresentable<T>(instance: any): instance is IPropertyPresentable<T> {
  return instance
      && (instance.getValue !== undefined);
}
